<template>
  <div id="dashboard-page">
    <v-row class="m-0 breadcrumb">
      <v-col cols="12" class="form-group">
        <h4 class="heading no-wrap"><v-icon>mdi-home</v-icon> Reports Page</h4>
      </v-col>
    </v-row>
    <v-row class="m-0" style="padding: 0 12px;">
      <v-col md="4">
        <v-autocomplete
            chips
            label="Search Customers"
            v-model="selectedCustomer"
            :items="getCustomerList"
            v-on:keyup="searchCustomerByChar"
            :loading="loadingCustomer"
            variant="outlined"
            class="m-0 p-0 search-autocomplete"
            style="min-height: auto !important;"
            multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            >
                    (+{{ selectedCustomer.length - 1 }} others)
                  </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="4">
        <v-autocomplete
            chips
            label="Search Sales Manager"
            v-model="selectedSalesManager"
            :items="getSalesManagerList"
            v-on:keyup="searchSalesManagerByChar"
            variant="outlined"
            class="m-0 p-0 search-autocomplete"
            style="min-height: auto !important;"
            multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            >
                    (+{{ selectedSalesManager.length - 1 }} others)
                  </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="3" style="padding-right: 0;">
        <v-autocomplete
            chips
            label="Search Opportunity Owner"
            v-model="selectedOpportunityOwner"
            :items="getOpportunityOwnerList"
            v-on:keyup="searchOpportunityOwnerByChar"
            :loading="loadingOpportunityOwner"
            variant="outlined"
            class="m-0 p-0 search-autocomplete"
            style="min-height: auto !important;"
            multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            >
                    (+{{ selectedOpportunityOwner.length - 1 }} others)
                  </span>
          </template>
        </v-autocomplete>
      </v-col>
      <!----Search Button---->
      <v-col md="1" style="padding-left: 0;">
        <v-btn variant="primary" class="search-button w-100" id="myfilterSearch" ref="myCheckRef" @click="callApiData">
          <v-icon medium class="text-white">mdi-account-search</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div class="w-100 fr" style="padding: 0 22px;">
      <v-btn class="remove-button fr"  @click.prevent="isActive = !isActive"  style="background-color: transparent !important;height: auto !important;" :disabled="disableDropDownData">+Advance Search</v-btn>
    </div>
    <!------ Advance Search Start --->
    <div class="advance-search-div" v-if="isActive===true">
      <v-card class="p-10">
        <v-row class="m-0 p-0">
          <v-col md="3">
            <mc-multi-select
                label="Region"
                hiddenlabel
                placeholder="Select Region"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedRegion"
                name="region"
            >
              <mc-option v-for="(item, index) in getRegionList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Area"
                hiddenlabel
                placeholder="Select Area"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedArea"
                name="area"
            >
              <mc-option v-for="(item, index) in getAreaList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Trade"
                hiddenlabel
                placeholder="Select Trade"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedTrade"
                name="trade"
            >
              <mc-option v-for="(item, index) in getTradeList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Brand"
                hiddenlabel
                placeholder="Select Brand"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedBrand"
                name="brand"
            >
              <mc-option v-for="(item, index) in getBrandList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Cargo"
                hiddenlabel
                placeholder="Select Cargo"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedCargo"
                name="cargo"
            >
              <mc-option v-for="(item, index) in getCargoList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Product"
                hiddenlabel
                placeholder="Select Product"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedProduct"
                name="product"
            >
              <mc-option v-for="(item, index) in getProductList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Sales Channel"
                hiddenlabel
                placeholder="Select Sales Channel"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedSalesChannel"
                name="salesChannel"
            >
              <mc-option v-for="(item, index) in getSalesChannelList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="12">
            <span style="float:left; margin-top: 38px;">CEM score</span>
            <v-range-slider
                v-model="cemScore"
                max="500"
                min="-500"
                strict
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                thumb-label="always"
                style="margin-top: 35px;"
            ></v-range-slider>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <!------ Advance Search End --->
    <v-row class="m-0" style="padding: 0 12px;">
      <!---
      <v-col xl="auto">
        <mc-multi-select
            label="Sales Manager"
            hiddenlabel
            placeholder="Select Sales Manager"
            selectalllabel="Select all"
            clearalllabel="Clear all"
            summarylabel="# out of # selected"
            fit="medium"
            optionswidth="trigger"
            @input="callApiData"
            :loading="loadDropDownData"
            :disabled="disableDropDownData"
            :value.prop="selectedSalesManager"
            name="salesManager"
        >
          <mc-option v-for="(item, index) in getSalesManagerList" :key="index" :value="item">{{ item }}</mc-option>
        </mc-multi-select>
      </v-col>
      <v-col xl="auto">
        <mc-multi-select
            label="Opportunity Owner"
            hiddenlabel
            placeholder="Select Opportunity Owner"
            selectalllabel="Select all"
            clearalllabel="Clear all"
            summarylabel="# out of # selected"
            fit="medium"
            optionswidth="trigger"
            @input="callApiData"
            :loading="loadDropDownData"
            :disabled="disableDropDownData"
            :value.prop="selectedOpportunityOwner"
            name="opportunityOwner"
        >
          <mc-option v-for="(item, index) in getOpportunityOwnerList" :key="index" :value="item">{{ item }}</mc-option>
        </mc-multi-select>
      </v-col>
      -->
    </v-row>
    <v-row class="m-0">
      <v-col md="6">
        <v-card>
            <v-data-table
                          :headers="salesControlHeaders"
                          :items="salesControlItem"
                          :single-expand="singleSalesControlExpand"
                          :items-per-page="5"
                          item-key="salesRegion"
                          :loading="loadSalesControlTable"
                          show-expand
                          id="salesControlTable">
              <template v-slot:[`item.data-table-expand`]="{ expand,item, isExpanded }">
                <v-btn icon
                       @click="expand(!isExpanded),areaLevelDetails(item,isExpanded,'tradeLevel')"
                       class="v-data-table__expand-icon"
                       :class="{'v-data-table__expand-icon--active' : isExpanded}"
                ><v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
                <span>{{ converting(item.simulatedPipelineFFE) }}</span>
              </template>
              <template v-slot:[`item.pipelineFFE`]="{ item }" >
                <span>{{ converting(item.pipelineFFE) }}</span>
              </template>
              <template v-slot:[`item.delta`]="{ item }" >
                <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
                <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
              </template>
              <template v-slot:body.append>
                <tr class="sticky-table-footer table-total-row">
                  <th scope="col" class="title text-center"></th>
                  <th scope="col" class="title text-left">Totals</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableSalesControl('simulatedPipelineFFE')))}}</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableSalesControl('pipelineFFE')))}}</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableSalesControl('delta')))}}</th>
                </tr>
              </template>
              <template v-slot:expanded-item="{ headers }">
                <td :colspan="headers.length" class="p-0 position-relative childBody">

                      <v-data-table
                          :headers="areaHeaders"
                          :items="areaLevelItem"
                          :loading="loadAreaTable"
                          :single-expand="singleRegionAreaExpand"
                          :items-per-page="5"
                          item-key="salesArea"
                          class="separator m-15"
                          show-expand
                          id="salesControlTradeTable">
                          <template v-slot:[`item.data-table-expand`]="{ expand,item, isExpanded }">
                            <v-btn icon
                                   @click="expand(!isExpanded),countryLevelDetails(item,isExpanded,'countryLevel')"
                                   class="v-data-table__expand-icon"
                                   :class="{'v-data-table__expand-icon--active' : isExpanded}"
                            ><v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
                            <span>{{ converting(item.simulatedPipelineFFE) }}</span>
                          </template>
                          <template v-slot:[`item.pipelineFFE`]="{ item }" >
                            <span>{{ converting(item.pipelineFFE) }}</span>
                          </template>
                          <template v-slot:[`item.delta`]="{ item }" >
                            <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
                            <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
                          </template>
                          <template v-slot:body.append>
                            <tr class="sticky-table-footer table-total-row">
                              <th scope="col" class="title text-center"></th>
                              <th scope="col" class="title text-left">Totals</th>
                              <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableSalesArea('simulatedPipelineFFE')))}}</th>
                              <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableSalesArea('pipelineFFE')))}}</th>
                              <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableSalesArea('delta')))}}</th>
                            </tr>
                          </template>
                        <template v-slot:expanded-item="{ headers }">
                            <td :colspan="headers.length" class="p-0 position-relative">
                              <v-card>
                                <v-data-table
                                    :headers="regionAreaCountryHeaders"
                                    :items="regionAreaCountryItem"
                                    class="m-15"
                                    :loading="loadRegionAreaCountryTable"
                                    :items-per-page="5"
                                    id="regionAreaCountryTable">
                                  <template v-slot:body="{items}">
                                    <tbody>
                                    <tr v-for="(itemVal,index) in items" :key="index" role="row">
                                      <td class="text-left">{{ itemVal.salesCountry }}</td>
                                      <td class="text-center">{{ converting(itemVal.simulatedPipelineFFE) }}</td>
                                      <td class="text-center">{{ converting(itemVal.pipelineFFE) }}</td>
                                      <td class="text-center">
                                        <mc-tag v-if="itemVal.pipelineFFE < itemVal.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(itemVal.delta) }}</mc-tag>
                                        <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(itemVal.delta) }}</mc-tag>
                                      </td>
                                    </tr>
                                    <tr class="sticky-table-footer table-total-row">
                                      <th scope="col" class="title text-left">Totals</th>
                                      <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldThirdTableCountry('simulatedPipelineFFE'))) }}</th>
                                      <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldThirdTableCountry('pipelineFFE'))) }}</th>
                                      <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldThirdTableCountry('delta'))) }}</th>
                                    </tr>
                                    </tbody>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </td>
                        </template>
                      </v-data-table>
                </td>
              </template>
            </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card>
          <v-data-table
              :headers="exportRegionHeaders"
              :items="exportRegionItem"
              :single-expand="singleExportRegionExpand"
              :items-per-page="5"
              item-key="region"
              :loading="loadExportRegionTable"
              show-expand
              id="exportRegionTable">
            <template v-slot:[`item.data-table-expand`]="{ expand,item, isExpanded }">
              <v-btn icon
                     @click="expand(!isExpanded),exportRegionTradeLevelDetails(item,isExpanded,'tradeLevel')"
                     class="v-data-table__expand-icon"
                     :class="{'v-data-table__expand-icon--active' : isExpanded}"
              ><v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
              <span>{{ converting(item.simulatedPipelineFFE) }}</span>
            </template>
            <template v-slot:[`item.pipelineFFE`]="{ item }" >
              <span>{{ converting(item.pipelineFFE) }}</span>
            </template>
            <template v-slot:[`item.delta`]="{ item }" >
              <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
              <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
            </template>
            <template v-slot:body.append>
              <tr class="sticky-table-footer table-total-row">
                <th scope="col" class="title text-center"></th>
                <th scope="col" class="title text-left">Totals</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableExportRegion('simulatedPipelineFFE')))}}</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableExportRegion('pipelineFFE')))}}</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableExportRegion('delta')))}}</th>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers }">
              <td :colspan="headers.length" class="p-0 position-relative childBody">
                <v-card>
                    <v-data-table
                        :headers="exportRegionTradeHeaders"
                        :items="exportRegionTradeItem"
                        class="separator m-15 first-child-nested-table first-child-alignment"
                        :loading="loadExportRegionTradeTable"
                        :items-per-page="5"
                        id="exportRegionTradeTable">
                      <template v-slot:body="{items}">
                        <tbody>
                        <tr v-for="(itemVal,index) in items" :key="index" role="row">
                          <td class="text-center">{{ itemVal.tradeDirectionCode }}</td>
                          <td class="text-center">{{ converting(itemVal.simulatedPipelineFFE) }}</td>
                          <td class="text-center">{{ converting(itemVal.pipelineFFE) }}</td>
                          <td class="text-center">
                            <mc-tag v-if="itemVal.pipelineFFE < itemVal.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(itemVal.delta) }}</mc-tag>
                            <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(itemVal.delta) }}</mc-tag>
                          </td>
                        </tr>
                        <tr class="sticky-table-footer table-total-row">
                          <th scope="col" class="title text-center">Totals</th>
                          <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldSecondTableTrade('simulatedPipelineFFE'))) }}</th>
                          <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldSecondTableTrade('pipelineFFE'))) }}</th>
                          <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldSecondTableTrade('delta'))) }}</th>
                        </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                </v-card>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card>
          <v-data-table
              :headers="tradeDirectionHeaders"
              :items="tradeDirectionItem"
              :loading="loadTradeDirectionTable"
              :items-per-page="5"
              item-key="tradeDirectionCode"
              id="tradeTable">
            <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
              <span>{{ converting(item.simulatedPipelineFFE) }}</span>
            </template>
            <template v-slot:[`item.pipelineFFE`]="{ item }" >
              <span>{{ converting(item.pipelineFFE) }}</span>
            </template>
            <template v-slot:[`item.delta`]="{ item }" >
              <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
              <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
            </template>
            <template v-slot:body.append>
              <tr class="sticky-table-footer table-total-row">
                <th scope="col" class="title text-center">Totals</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableTrade('simulatedPipelineFFE')))}}</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableTrade('pipelineFFE')))}}</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableTrade('delta')))}}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col md="6">
        <v-card>
          <v-data-table
              :headers="productHeaders"
              :items="productItem"
              :loading="loadProductTable"
              :items-per-page="5"
              item-key="productCode"
              id="productTable">
            <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
              <span>{{ converting(item.simulatedPipelineFFE) }}</span>
            </template>
            <template v-slot:[`item.pipelineFFE`]="{ item }" >
              <span>{{ converting(item.pipelineFFE) }}</span>
            </template>
            <template v-slot:[`item.delta`]="{ item }" >
              <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
              <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
            </template>
            <template v-slot:body.append>
              <tr class="sticky-table-footer table-total-row">
                <th scope="col" class="title text-left">Totals</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableProduct('simulatedPipelineFFE')))}}</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableProduct('pipelineFFE')))}}</th>
                <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableProduct('delta')))}}</th>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import "@maersk-global/mds-components-core/mc-multi-select";
import "@maersk-global/mds-components-core/mc-option";
import "@maersk-global/mds-components-core/mc-icon";
import "@maersk-global/mds-components-core/mc-input";
import "@maersk-global/mds-components-core/mc-table";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { avActions } from "@/actions";

export default {
  name: "ReportsPage",
  components: {
  },
  props: ['filterData'],
  data: () => ({
    salesControlItem : [],
    exportRegionItem : [],
    tradeDirectionItem : [],
    productItem : [],
    exportRegionTradeItem : [],
    regionAreaCountryItem: [],
    loadSalesControlTable: true,
    loadExportRegionTable: true,
    loadTradeDirectionTable: true,
    loadExportRegionTradeTable: true,
    loadRegionAreaCountryTable: true,
    loadAreaTable: true,
    loadProductTable: true,
    regionAreaCountryHeaders : [
      { text: 'Country', value: 'salesCountry',align: 'left',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    salesControlHeaders : [
      { text: 'Sales Control', value: 'salesRegion',align: 'left',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    exportRegionHeaders : [
      { text: 'Export Region', value: 'region',align: 'left',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    exportRegionTradeHeaders : [
      { text: 'Trade', value: 'tradeDirectionCode',align: 'center',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    tradeDirectionHeaders : [
      { text: 'Trade', value: 'tradeDirectionCode',align: 'center',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    productHeaders : [
      { text: 'Product', value: 'productCode',align: 'left',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    isActive:false,
    enableSearch: false,
    monthlySplitHeaders : [
      { text: 'Year Month', value: 'yearMonth',align: 'center',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    monthlySplitData: [],
    dialogHeading: '',
    monthlySplitDialog: false,
    loadingCustomer: false,
    loadingSalesManager: false,
    loadingOpportunityOwner: false,
    loadDropDownData: false,
    disableDropDownData: true,
    getOpportunityOwnerList: [],
    getSalesManagerList: [],
    getSalesChannelList: [],
    getProductList: [],
    getCargoList: [],
    getBrandList: [],
    getTradeList: [],
    getAreaList: [],
    getRegionList: [],
    getCustomerList: [],
    autocompleteValue: [],
    selectedCustomer: [],
    selectedRegion: [],
    selectedArea: [],
    selectedTrade: [],
    selectedBrand: [],
    selectedCargo: [],
    selectedProduct: [],
    selectedSalesChannel: [],
    selectedSalesManager: [],
    selectedOpportunityOwner: [],
    showCustomerLoading: false,
    customervalue: '',
    series: [{
      name: 'Recommended Pipeline',
      data: [44, 55, 57, 56, 61, 58, 63, 60, 66, 57, 56, 61]
    }, {
      name: 'Existing Pipeline',
      data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 101, 98, 87]
    }],
    chartOptions: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['202501', '202502', '202503', '202504', '202505', '202506', '202507', '202508', '202509', '202510', '202511', '202512'],
      },
      colors: ['#43afd4', '#13253b'],
      yaxis: {
        title: {
          text: 'Volumes'
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + ' Volumes'
          }
        }
      }
    },
    cemScore: [0,0],
    cemMax: 500,
    cemMin: -500,
    showCustomerTable : false,
    searchCustomer: '',
    tradeLevelItem: [],
    areaLevelItem: [],
    search: '',
    singleSalesControlExpand: true,
    singleExportRegionExpand: true,
    singleRegionAreaExpand: true,
    tradeHeaders : [
      { text: 'Trade', value: 'trade',align: 'left',sortable: true, filterable: true },
      { text: 'Recommendation', helpText: '',desc:'', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc: '', value: 'delta', align: 'center', sortable: true },
    ],
    areaHeaders : [
      { text: '', value: 'data-table-expand',desc: '', align: 'center'},
      { text: 'Sales Area', value: 'salesArea',align: 'left',sortable: true, filterable: true },
      { text: 'Recommendation', helpText: '',desc:'', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc: '', value: 'delta', align: 'center', sortable: true },
    ],
    customerHeaders: [
      { text: '', value: 'data-table-expand',desc: '', align: 'center'},
      { text: 'Customer', helpText: '',desc: '', value: 'customerName', sortable: true, filterable: true, align: 'left'},
      { text: 'Recommendation', helpText: '',desc: '', value: 'simulatedPipelineFFE', sortable: true, align: 'center'},
      { text: 'Existing', helpText: '',desc:'', value: 'pipelineFFE', sortable: true, align: 'center'},
      { text: 'Delta', helpText: '',desc:'', value: 'delta', sortable: true, align: 'center'},
      { text: 'REV per FFE', helpText: '',desc: '', value: 'cyPerFFE', sortable: true, align: 'center'},
      { text: 'CF%', helpText: '',desc: '', value: 'cfPerc', sortable: true, align: 'center'},
      { text: 'LnS Pipeline', helpText: '',desc:'', value: 'rofoFFE', sortable: true, align: 'center'},
    ],
    customerItem:[],
    customerNameSelectedTable: '',
    monthlyViewTableLoading: true,
    selectedSalesRegionTable: '',
  }),
  created() {
    this.initialize();
    const retrievedData = sessionStorage.getItem("selectedFilterData");
    const parsedData = JSON.parse(retrievedData);
    this.selectedBrand = parsedData.brand;
    this.selectedSalesChannel = parsedData.salesChannel;
    this.selectedProduct = parsedData.productNames;
    this.selectedCargo = parsedData.cargo;
    this.selectedTrade = parsedData.tradeDirectionCodes;
    this.selectedArea = parsedData.areas;
    this.selectedRegion = parsedData.regions;
    this.cemMin = parsedData.cemMin;
    this.cemMax = parsedData.cemMax;
    this.cemScore = [this.cemMin,this.cemMax];
    this.getCustomerList = parsedData.customers;
    this.getSalesManagerList = parsedData.accountManagers;
    this.getOpportunityOwnerList = parsedData.accountOwners;
    this.selectedCustomer = parsedData.customers;
    this.selectedSalesManager = parsedData.accountManagers;
    this.selectedOpportunityOwner = parsedData.accountOwners;
    this.callApiData();
  },
  mounted() {
  },
  methods : {
    sumFieldFirstTableSalesControl(key) {
      // sum data in give key (property)
      return this.salesControlItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldFirstTableSalesArea(key) {
      // sum data in give key (property)
      return this.areaLevelItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldFirstTableExportRegion(key) {
      // sum data in give key (property)
      return this.exportRegionItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldFirstTableTrade(key) {
      // sum data in give key (property)
      return this.tradeDirectionItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldFirstTableProduct(key) {
      // sum data in give key (property)
      return this.productItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldSecondTableArea(key) {
      // sum data in give key (property)
      return this.areaLevelItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldSecondTableTrade(key) {
      // sum data in give key (property)
      return this.exportRegionTradeItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldThirdTableCountry(key) {
      // sum data in give key (property)
      return this.regionAreaCountryItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldMonthlySplitTable(key) {
      // sum data in give key (property)
      return this.monthlySplitData.reduce((a, b) => a + (b[key] || 0), 0);
    },
    async areaLevelDetails(item, isExpanded, data){
      this.areaLevelItem = [];
      this.loadAreaTable = true;
      this.selectedSalesRegionTable = item.salesRegion;
      console.log("isExpanded-"+isExpanded);
      console.log("Data-"+data);
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": [item.salesRegion],
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": this.selectedCustomer,
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getSalesAreaLevelOptions = await avActions.getSalesAreaLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const getSalesAreaLevelResponse = await AxiosFetchForMsal(getSalesAreaLevelOptions);

      if (getSalesAreaLevelResponse.status === 200) {
        this.areaLevelItem = getSalesAreaLevelResponse.data;
        this.loadAreaTable = false;
      }
    },
    async exportRegionTradeLevelDetails(item, isExpanded, data){
      this.exportRegionTradeItem = [];
      this.loadExportRegionTradeTable = true;
      console.log("isExpanded-"+isExpanded);
      console.log("Data-"+data);
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": this.selectedRegion,
        "selectedExportRegion": item.region,
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": this.selectedCustomer,
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getTradeLevelOptions = await avActions.getExportRegionTradeLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const getTradeLevelResponse = await AxiosFetchForMsal(getTradeLevelOptions);

      if (getTradeLevelResponse.status === 200) {
        this.exportRegionTradeItem = getTradeLevelResponse.data;
        this.loadExportRegionTradeTable = false;
      }
    },
    async countryLevelDetails(item, isExpanded, data){
      this.regionAreaCountryItem = [];
      this.loadRegionAreaCountryTable = true;
      console.log("isExpanded-"+isExpanded);
      console.log("Data-"+data);
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": [this.selectedSalesRegionTable],
        "areas":  [item.salesArea],
        "salesChannel": this.selectedSalesChannel,
        "customers": this.selectedCustomer,
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getSalesCountryLevelOptions = await avActions.getSalesCountryLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const getSalesCountryLevelResponse = await AxiosFetchForMsal(getSalesCountryLevelOptions);

      if (getSalesCountryLevelResponse.status === 200) {
        this.regionAreaCountryItem = getSalesCountryLevelResponse.data;
        this.loadRegionAreaCountryTable = false;
      }
    },
    async searchCustomerByChar(event) {
      this.keywords=event.target.value;
      console.log(this.keywords);
      if (this.keywords.length >= 3 && event.which <= 90 && event.which >= 48) {
        this.loadingCustomer = true;
        const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
        const getCalendarListOptions = await avActions.getCustomerDetails(
            this.keywords,
            accessTokenCheck.idToken
        );
        const getCustomerDetailsResponse = await AxiosFetchForMsal(
            getCalendarListOptions
        );
        if (getCustomerDetailsResponse.status === 200) {
          if(this.selectedCustomer.length>0){
            this.arrCustomerSelected= getCustomerDetailsResponse.data.toSorted();
            this.getCustomerList = this.arrCustomerSelected.concat(this.selectedCustomer);
          }else{
            this.getCustomerList = getCustomerDetailsResponse.data.toSorted();
          }
          this.loadingCustomer = false;
        }
      }
    },
    async searchOpportunityOwnerByChar(event) {
      this.keywords=event.target.value;
      console.log(this.keywords);
      if (this.keywords.length >= 3 && event.which <= 90 && event.which >= 48) {
        this.loadingOpportunityOwner = true;
        const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
        const getOpportunityOwnerOptions = await avActions.getDistinctAccountOwnersDetails(
            this.keywords,
            accessTokenCheck.idToken
        );
        const getOpportunityOwnerResponse = await AxiosFetchForMsal(
            getOpportunityOwnerOptions
        );
        if (getOpportunityOwnerResponse.status === 200) {
          if(this.selectedOpportunityOwner.length>0){
            this.arrOpportunityOwnerSelected = getOpportunityOwnerResponse.data.toSorted();
            this.getOpportunityOwnerList = this.arrOpportunityOwnerSelected.concat(this.selectedOpportunityOwner);
          }else{
            this.getOpportunityOwnerList = getOpportunityOwnerResponse.data.toSorted();
          }
          this.loadingOpportunityOwner = false;
        }
      }
    },
    async searchSalesManagerByChar(event) {
      this.keywords=event.target.value;
      console.log(this.keywords);
      if (this.keywords.length >= 3 && event.which <= 90 && event.which >= 48) {
        this.loadingSalesManager = true;
        const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
        const getSalesManagerOptions = await avActions.getDistinctSalesManagerDetails(
            this.keywords,
            accessTokenCheck.idToken
        );
        const getSalesManagerResponse = await AxiosFetchForMsal(
            getSalesManagerOptions
        );
        if (getSalesManagerResponse.status === 200) {
          if(this.selectedSalesManager.length>0){
            this.arrSalesManagerSelected = getSalesManagerResponse.data.toSorted();
            this.getSalesManagerList = this.arrSalesManagerSelected.concat(this.selectedSalesManager);
          }else{
            this.getSalesManagerList = getSalesManagerResponse.data.toSorted();
          }
          this.loadingSalesManager = false;
        }
      }
    },
    thousandSeprator(amount) {
      if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
        return amount;
      } else {
        return amount;
      }
    },
    converting(labelValue) {
      const absValue = Math.abs(Number(labelValue));
      const sign = Math.sign(Number(labelValue)) === -1 ? '-' : ''; // Preserve the sign of the value

      const formatValue = (num) => {
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
      };

      return absValue >= 1.0e+9
          ? sign + (absValue / 1.0e+9).toFixed(0) + "B"
          : absValue >= 1.0e+6
              ? sign + (absValue / 1.0e+6).toFixed(2) + "M"
              : absValue >= 1.0e+3
                  ? sign + (absValue / 1.0e+3).toFixed(2) + "K"
                  : sign + this.thousandSeprator(formatValue(absValue));
    },
    replaceValueInArray(arr, oldValue, newValue) {
      return arr.map(item => item === oldValue ? newValue : item);
    },
    async initialize() {
      this.loadDropDownData = true;
      this.disableDropDownData = true;
      const postBody = {
        "brand": [],
        "productNames": [],
        "tradeDirectionCodes": [],
        "cargo": [],
        "regions": [],
        "areas": [],
        "salesChannel": [],
        "customers": [],
        "accountManagers": [],
        "accountOwners": [],
        "cemMin": null,
        "cemMax": null
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getDropDownListOptions = await avActions.getDropDownListDetails(
          postBody,
          accessTokenCheck.idToken
      );

      const getDropDownListResponse = await AxiosFetchForMsal(
          getDropDownListOptions
      );

      if (getDropDownListResponse.status === 200) {
        this.getBrandList = getDropDownListResponse.data.brand;
        this.getSalesChannelList = getDropDownListResponse.data.salesChannel;
        this.getProductList = getDropDownListResponse.data.productNames;
        this.getCargoList = getDropDownListResponse.data.cargo;
        this.getBrandList = getDropDownListResponse.data.brand;
        this.getTradeList = getDropDownListResponse.data.tradeDirectionCodes;
        getDropDownListResponse.data.areas = this.replaceValueInArray(
            getDropDownListResponse.data.areas,
            "CENTRAL AMERICA, ANDINA, CARIBBEAN",
            "CENTRAL AMERICA | ANDINA | CARIBBEAN"
        );
        this.getAreaList = getDropDownListResponse.data.areas;
        this.getRegionList = getDropDownListResponse.data.regions;

        //this.cemMin = getDropDownListResponse.data.cemMin;
        //this.cemMax = getDropDownListResponse.data.cemMax;
        //this.cemScore = [this.cemMin,this.cemMax];
        this.loadDropDownData = false;
        this.disableDropDownData = false;
        //console.log("getDropDownListResponse-"+JSON.stringify(getDropDownListResponse.data));
      }
    },
    async loadTableData(){
      const postBodyData = {
        "brand": [],
        "productNames": [],
        "tradeDirectionCodes": [],
        "cargo": [],
        "regions": [],
        "areas": [],
        "salesChannel": [],
        "customers": [],
        "accountManagers": [],
        "accountOwners": [],
        "cemMin": null,
        "cemMax": null
      };
      await this.salesControlTableLoad(postBodyData);
      await this.exportRegionTableLoad(postBodyData);
      await this.tradeDirectionTableLoad(postBodyData);
      await this.productTableLoad(postBodyData);
    },
    async salesControlTableLoad(postBody){
      this.salesControlItem = [];
      this.loadSalesControlTable = true;
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const salesControlListOptions = await avActions.getSalesRegionLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const salesControlResponse = await AxiosFetchForMsal(
          salesControlListOptions
      );

      if(salesControlResponse.status === 200){
        this.salesControlItem = salesControlResponse.data;
        this.loadSalesControlTable = false;
      }
    },
    async exportRegionTableLoad(postBody){
      this.exportRegionItem = [];
      this.loadExportRegionTable = true;
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const exportRegionListOptions = await avActions.getExportRegionLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const exportRegionResponse = await AxiosFetchForMsal(
          exportRegionListOptions
      );

      if(exportRegionResponse.status === 200){
        this.exportRegionItem = exportRegionResponse.data;
        this.loadExportRegionTable = false;
      }
    },
    async tradeDirectionTableLoad(postBody){
      this.tradeDirectionItem = [];
      this.loadTradeDirectionTable = true;
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const tradeDirectionListOptions = await avActions.getTradeLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const tradeDirectionResponse = await AxiosFetchForMsal(
          tradeDirectionListOptions
      );

      if(tradeDirectionResponse.status === 200){
        this.tradeDirectionItem = tradeDirectionResponse.data;
        this.loadTradeDirectionTable = false;
      }
    },
    async productTableLoad(postBody){
      this.productItem = [];
          this.loadProductTable = true;
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const productListOptions = await avActions.getProductLevelReportList(
          postBody,
          accessTokenCheck.idToken
      );

      const productResponse = await AxiosFetchForMsal(
          productListOptions
      );

      if(productResponse.status === 200){
        this.productItem = productResponse.data;
        this.loadProductTable = false;
      }
    },
    inputChanges(){
      if(event.target.label==='Region'){
        this.selectedRegion = event.target.value;
      }else if(event.target.label==='Area'){
        this.selectedArea = event.target.value;
      }else if(event.target.label==='Trade'){
        this.selectedTrade = event.target.value;
      }else if(event.target.label==='Brand'){
        this.selectedBrand = event.target.value;
      }else if(event.target.label==='Cargo'){
        this.selectedCargo = event.target.value;
      }else if(event.target.label==='Product'){
        this.selectedProduct = event.target.value;
      }else if(event.target.label==='Sales Channel'){
        this.selectedSalesChannel = event.target.value;
      }else if(event.target.label==='cemScore'){
        this.cemScore = event.target.value;
      }
    },
    async callApiData() {
      this.isActive = false;
      this.salesControlItem = [];
      this.areaLevelItem = [];
      this.regionAreaCountryItem = [];
      this.exportRegionItem = [];
      this.exportRegionTradeItem = [];
      this.tradeDirectionItem = [];
      this.productItem = [];
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": this.selectedRegion,
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": this.selectedCustomer,
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      await this.saveDashboardFilters(postBody);
      await this.salesControlTableLoad(postBody);
      await this.exportRegionTableLoad(postBody);
      await this.tradeDirectionTableLoad(postBody);
      await this.productTableLoad(postBody);
    },
    async saveDashboardFilters(postBody){
      sessionStorage.setItem("selectedFilterData",JSON.stringify(postBody));
      const savePostBody = {
        "userEmail": sessionStorage.getItem("userEmail"),
        "crDropDownList": postBody
      }
      console.log("savePostBody-"+JSON.stringify(savePostBody));
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const saveDashboardOptions = await avActions.saveDashboardFilterList(
          savePostBody,
          accessTokenCheck.idToken
      );

      const saveDashboardResponse = await AxiosFetchForMsal(saveDashboardOptions);

      if(saveDashboardResponse.status === 200){
        console.log('saveDashboardResponse-'+saveDashboardResponse.data);
      }

    }
  }
}
</script>

<style scoped>
.border-left{
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}
.border-bottom{
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.search-autocomplete .v-select.v-select--chips .v-select__selections{
  min-height: auto !important;
}

.customer-view-icon .mc-icon {
  display: inline-block;
  width: 100%;
}

.filter-rows .col-md-2{
  padding: 4px !important;

}

.advance-search-div{
  position: absolute;
  z-index: 2;
  top: 140px;
  right: 20px;
  width: 80%;
}

#myfilterSearch{
  background-color: #00243d;
}
</style>
